export namespace IAddressSchema {
  /**
   * Return an instance of IAddressSchema with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IAddressSchema>): IAddressSchema =>
    ({
      required_fields: [],
      labels: {},
      ...(partial ?? {}),
    }) as IAddressSchema;
}

export interface IAddressSchema {
  display_format: string | undefined;
  input_format: string | undefined;
  required_fields: Array<string>;
  labels: Partial<Record<string, string>>;
  postal_code_regex_pattern: string | undefined;
  input_format_for_two_columns: string | undefined;
}
